import { get } from 'lodash-es';
import { STATE_MENU } from '../EditSalesRoute.enum';
import { statusSalesRouteEnum } from '../../../Services/SalesRoutes/enum';

const menuConditions = {
  closed: {
    sequence: 1,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.CLOSED,
    data: ({ menu, onlyState }) => ({
      menu,
      common: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  documents: {
    sequence: 2,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.SUBSCRIBED,
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
      current: {
        code: 'documents',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
    }),
  },
  subscription: {
    sequence: 3,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      (srStatus === statusSalesRouteEnum.SIMULATED || srStatus === statusSalesRouteEnum.ONHOLD) &&
      get(salesroute, 'contracts') &&
      salesroute.contracts.length &&
      get(quotation, 'offer') &&
      quotation.offer.length,
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'subscription',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  offers: {
    sequence: 4,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.SIMULATED /*  || (get(quotation, 'offer') && quotation.offer.length) */,
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'offers',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  generalData: {
    sequence: 5,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.COVEREDDESCRIBED ||
      srStatus === statusSalesRouteEnum.GENERALDATADESCRIBED ||
      (srStatus === statusSalesRouteEnum.INPROGRESS && get(salesroute, 'quotations[0].start')),
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'generalData',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  generalDataExtraData: {
    sequence: 5,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.EXTRADATADESCRIBED ||
      srStatus === statusSalesRouteEnum.GENERALDATADESCRIBED ||
      (srStatus === statusSalesRouteEnum.INPROGRESS && get(salesroute, 'quotations[0].start')),
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'generalData',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  extra_data: {
    sequence: 6,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.COVEREDDESCRIBED,
    // || (srStatus === statusSalesRouteEnum.INPROGRESS && get(salesroute, 'quotations[0].start')),
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'extra_data',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  quotationsLoans: {
    sequence: 7,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.LOANSDESCRIBED ||
      (srStatus === statusSalesRouteEnum.INPROGRESS && get(salesroute, 'loans')),
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'quotations',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  quotations: {
    sequence: 7,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.PRESIMULATED ||
      (srStatus === statusSalesRouteEnum.INPROGRESS &&
        quotation &&
        (!get(quotation, 'offer') || !quotation.offer.length) &&
        get(questionnaireSalesRoute, 'parts[0].answers') &&
        get(questionnaireSalesRoute, 'parts[0].results')) ||
      (!quotation &&
        get(questionnaireSalesRoute, 'parts[0].answers') &&
        get(questionnaireSalesRoute, 'parts[0].results')),
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'quotations',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  loans: {
    sequence: 8,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.PRESIMULATED ||
      (srStatus === statusSalesRouteEnum.INPROGRESS &&
        !quotation &&
        get(questionnaireSalesRoute, 'parts[0].answers') &&
        get(questionnaireSalesRoute, 'parts[0].results')),
    data: ({ menu, onlyState }) => ({
      menu,
      before: { state: STATE_MENU.ENABLED, expanded: onlyState ? null : false },
      current: {
        code: 'loans',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
  questionnaires: {
    sequence: 9,
    condition: ({ srStatus, salesroute, quotation, questionnaireSalesRoute }) =>
      srStatus === statusSalesRouteEnum.CREATED ||
      // srStatus === statusSalesRouteEnum.COMPUTED ||
      !get(questionnaireSalesRoute, 'parts[0].results'),
    data: ({ menu, onlyState }) => ({
      menu,
      current: {
        code: 'questionnaires',
        state: onlyState ? STATE_MENU.ENABLED : STATE_MENU.CURRENT,
        expanded: onlyState ? null : true,
      },
      after: { state: STATE_MENU.DISABLED, expanded: onlyState ? null : false },
    }),
  },
};

export { menuConditions };
